import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig";
import SigninWidget from './components/auth/SigninWidget';
import UserHome from './components/pages/User Management/UserHome';
import ReportStore from './components/pages/ReportStore';
const App = () => {
  useEffect(() => {
    localStorage.setItem("historyListFlag", true);
    localStorage.setItem("historyCollapse", false);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route exact path="/" component={SigninWidget} />
          <Route path="/manage-user" component={UserHome} />
          <Route path="/report-store" component={ReportStore} />
          <Route path="/report-store" component={ReportStore} />

        </Switch>
      </Router>
    </MsalProvider>
  );
};

export default App;